import {Component, OnInit} from "@angular/core";
import {VideoWithUrl} from "src/app/model/video-youtube/video-youtube";
import {YoutubeService} from "./youtube.service";
import {map} from "rxjs/operators";
import {faAngleDoubleRight} from "@fortawesome/free-solid-svg-icons";
import {Observable} from "rxjs/internal/Observable";
import {ChannelApiService} from "../../api/channel-api.service";

@Component({
  selector: 'app-youtube',
  templateUrl: './youtube.component.html',
  styleUrls: ['./youtube.component.scss']
})
export class YoutubeComponent implements OnInit {

  readonly videos$: Observable<Array<VideoWithUrl>>;
  arrow = faAngleDoubleRight;

  constructor(
    private channelApi: ChannelApiService,
    readonly youtube: YoutubeService
  ) {
    this.videos$ = this.channelApi.getAll().pipe(
      map(videos => videos.map(video => <VideoWithUrl>{...video, embedUrl: this.youtube.getEmbedUrl(video)}))
    );
  }

  ngOnInit(): void {
  }
}
